import React, { Component, Fragment } from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/acai.css";

import AppContext from "../../contexts/AppContext";

class ServerError extends Component {
    state = {
        technicalError: false
    };

    showTechnicalError = () => {
        this.setState({
            technicalError: !this.state.technicalError
        });
    };

    render() {
        return (
            <AppContext.Consumer>
                {context => (
                    <Fragment>
                        {context.state.serverError === true ? (
                            <div className="serverError">
                                <div className="errorCenter">
                                    <div className="noDataTitle">Error</div>
                                    <div className="noDataComment">
                                        Application error please contact your
                                        system administrator or{" "}
                                        <a onClick={context.state.hideError}>
                                            click here
                                        </a>{" "}
                                        To try again .
                                    </div>
                                    <div className="noDataComment">
                                        <a onClick={this.showTechnicalError}>
                                            Display technical error
                                        </a>
                                    </div>
                                    {this.state.technicalError === true ? (
                                        <div className="noDataComment">
                                            <JSONPretty
                                                id="json-pretty"
                                                data={
                                                    context.state
                                                        .serverErrorMessage
                                                }
                                            ></JSONPretty>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </Fragment>
                )}
            </AppContext.Consumer>
        );
    }
}

export default ServerError;



// WEBPACK FOOTER //
// ./src/components/utilities/ServerError.js